import { useLocation } from 'react-router-dom'

import { SubProduct } from 'src/utils/product'

const useHasFooter = () => {
  const { pathname } = useLocation()
  return !pathname.includes(`/${SubProduct.ChatBot}`)
}

export default useHasFooter
